// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__Cwmjq","title":"Sidebar_title__v4l75","list":"Sidebar_list__C3Po+","list_item":"Sidebar_list_item__KRoD0"};